/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { ArchetypeResponse } from "./ArchetypeResponse";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum Http_methodEnum {
  "GET" = "GET",

  "POST" = "POST",

  "PUT" = "PUT",

  "DELETE" = "DELETE",

  "PATCH" = "PATCH",

  "OPTIONS" = "OPTIONS",

  "TRACE" = "TRACE"
}

// required attributes
const ArchetypeR = t.interface({
  responses: t.readonlyArray(ArchetypeResponse, "array of ArchetypeResponse"),

  tags: t.readonlyArray(t.string, "array of string"),

  http_method: enumType<Http_methodEnum>(Http_methodEnum, "http_method"),

  name: t.string,

  resource_url: t.string,

  subsystem: t.string,

  url_parameters: t.readonlyArray(t.string, "array of string")
});

// optional attributes
const ArchetypeO = t.partial({
  id: t.string
});

export const Archetype = t.intersection([ArchetypeR, ArchetypeO], "Archetype");

export type Archetype = t.TypeOf<typeof Archetype>;
